"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TPWearable = exports.Wearable = exports.WearableBodyShape = exports.WearableRepresentation = exports.Metrics = exports.Locale = exports.I18N = void 0;
var i18n_1 = require("./i18n");
Object.defineProperty(exports, "I18N", { enumerable: true, get: function () { return i18n_1.I18N; } });
var locale_1 = require("./locale");
Object.defineProperty(exports, "Locale", { enumerable: true, get: function () { return locale_1.Locale; } });
var metrics_1 = require("./metrics");
Object.defineProperty(exports, "Metrics", { enumerable: true, get: function () { return metrics_1.Metrics; } });
var representation_1 = require("./representation");
Object.defineProperty(exports, "WearableRepresentation", { enumerable: true, get: function () { return representation_1.WearableRepresentation; } });
var wearable_body_shape_1 = require("./wearable-body-shape");
Object.defineProperty(exports, "WearableBodyShape", { enumerable: true, get: function () { return wearable_body_shape_1.WearableBodyShape; } });
var wearable_1 = require("./wearable");
Object.defineProperty(exports, "Wearable", { enumerable: true, get: function () { return wearable_1.Wearable; } });
var tp_wearable_1 = require("./tp-wearable");
Object.defineProperty(exports, "TPWearable", { enumerable: true, get: function () { return tp_wearable_1.TPWearable; } });
//# sourceMappingURL=index.js.map